import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "../reducer/rootReducer";

const Store = configureStore(
    rootReducer,
);

export default Store;